var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.status ? 'pill-active' : 'pill-not-active',
    _vm.fixedWidth ? 'pill-fixed-width' : '',
    'pill-rounded',
    'text-center',
    'px-3',
  ]},[_c('span',{class:['pill-value', _vm.textBold && _vm.status ? 'font-weight-bold' : '']},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }